import { Button, Input, InputNumber, Popconfirm, Select, Table, Tooltip, message } from 'antd';
import React, { Component } from 'react';
import API_URL from '../../../../common/url';
import $ from "../../../../common/AjaxRequest";
import '../index.less';
import PaymentPlanSortModal from './PaymentPlanSortModal';

const Option = Select.Option;

const Config = {
    DetailedPaymentPlan: {
        title: '付款计划-详细版',
        queryUrl: API_URL.evaluate.queryDetailPaymentData,
        saveUrl: API_URL.evaluate.saveDetailPaymentData,
        InflationUrl: API_URL.evaluate.updatePaymentPlanHasInflation,
    },
    SimplePaymentPlan: {
        title: '付款计划-简版',
        queryUrl: API_URL.evaluate.querySimplePaymentData,
        saveUrl: API_URL.evaluate.saveSimplePaymentData,
        InflationUrl: API_URL.evaluate.updatePaymentPlanHasInflation,
    },
    FteSimplePaymentPlan: {
        title: '付款时间表',
        queryUrl: API_URL.evaluate.queryFteSimplePaymentData,
        saveUrl: API_URL.evaluate.saveFteSimplePaymentData,
        InflationUrl: API_URL.evaluate.updateFtePaymentPlanHasInflation,
    },
}

const byStageList = ['第一笔付款', '第二笔付款', '第三笔付款', '第四笔付款', '第五笔付款', '第六笔付款', '第七笔付款', '第八笔付款', '第九笔付款', '第十笔付款', '第十一笔付款', '第十二笔付款', '第十三笔付款', '第十四笔付款', '第十五笔付款', '第十六笔付款', '第十七笔付款', '第十八笔付款', '第十九笔付款', '第二十笔付款', '第二十一笔付款', '第二十二笔付款', '第二十三笔付款', '第二十四笔付款', '第二十五笔付款', '第二十六笔付款', '第二十七笔付款', '第二十八笔付款', '第二十九笔付款', '第三十笔付款'];

const paymentNodeList = ['合同签署后10个工作日内', '首例受试者完成入组', '完成入组合同约定随机例数*50%受试者', '项目层面入组结束', '数据锁库'];

const ftePaymentNodeList = ['合同签署后10个工作日内', '服务满六个月', '服务满十二个月', '服务满十八个月', '服务满二十四个月','服务满三十个月']

export default class PaymentPlan extends Component {

    state = {
        firTableData: [],  // 付款时间表
        secTableData: [],  // 收款账户信息表
        type: 'view',
        inflationBaseList: [],
        feesTotal:{},
        config: {},
    }

    componentDidMount() {
        const { clinicalQuotationRecordId, activeKey } = this.props;
        this.loadData(clinicalQuotationRecordId, activeKey);
        this.setInflationBaseList();
    }

    loadData = (clinicalQuotationRecordId, activeKey) => {
        if (!(clinicalQuotationRecordId && (activeKey == 'DetailedPaymentPlan' || activeKey == 'SimplePaymentPlan' || activeKey == 'FteSimplePaymentPlan'))) return
        const options = {
            method: 'POST',
            url: Config[activeKey].queryUrl,
            data: { clinicalQuotationRecordId },
            dataType: 'json',
            doneResult: res => {
                const { paymentAccountList = [], feesTotal = {}, paymentPlanList = [], totalPlan = {} } = res.data;
                this.setState({
                    feesTotal,
                    firTableData: [...paymentPlanList, totalPlan],
                    secTableData: paymentAccountList,
                    config: Config[activeKey],
                });
            }
        };
        $.sendRequest(options);
    }

    setInflationBaseList = () => {
        const { inflationBaseList } = this.state;
        for (let index = 0; index <= 10; index++) {
            inflationBaseList.push({
                label: `1.03^${index}=${(1.03 ** index).toFixed(6)}`,
                value: Number((1.03 ** index).toFixed(6)),
            });
            this.setState({ inflationBaseList });
        }
    }

    getFirColumns = () => {
        const { type, inflationBaseList } = this.state;
        const { paymentPlanHasInflation, activeKey } = this.props;
        const byStageOption = byStageList.map(el => <Option value={el}>{el}</Option>);
        const nodeList = activeKey == 'FteSimplePaymentPlan' ? ftePaymentNodeList : paymentNodeList; 
        const paymentNodeOption = nodeList.map(el => <Option key={el} value={el} title={el}>
            <Tooltip placement="right" title={el}>
                <span style={{ display: 'block', width: '100%', overflow: 'hidden' }}>{el}</span>
            </Tooltip>
        </Option>);
        const inflationBaseOption = inflationBaseList.map(el => <Option value={el.value}>{el.label}</Option>);
        const columns = [
            {
                title: '分期',
                dataIndex: 'byStageName',
                key: 'byStageName',
                width: 100,
                render: (text, record, index) => {
                    const { byStageName } = record;
                    return byStageName !== '总计' ? (type == 'edit' ? <span>
                        <Select
                            allowClear
                            style={{ width: '90%' }}
                            placeholder="请输入"
                            value={text}
                            onChange={value => this.handleFirChange(value, 'byStageName', index)}
                        >
                            {byStageOption}
                        </Select>
                    </span> : text) : text
                }
            },
            {
                title: '付款节点',
                dataIndex: 'paymentNode',
                key: 'paymentNode',
                width: 200,
                render: (text, record, index) => {
                    const { byStageName } = record;
                    return byStageName !== '总计' ? (type == 'edit' ? <span style={{ width: '90%' }}>
                        <Select
                            mode="combobox"
                            filterOption={true}
                            style={{ width: '90%' }}
                            placeholder="请输入"
                            value={text}
                            onChange={value => this.handleFirChange(value, 'paymentNode', index)}
                        >
                            {paymentNodeOption}
                        </Select>
                    </span> : text) : text
                }
            },
            {
                title: '付款比例',
                dataIndex: 'paymentPercent',
                key: 'paymentPercent',
                width: 120,
                render: (text, record, index) => {
                    const { byStageName } = record;
                    return (byStageName !== '总计' && type == 'edit') ? <span style={{ width: '90%' }}>
                        <InputNumber
                            style={{ width: '85%', marginRight: 5 }}
                            min={0}
                            precision={2}
                            placeholder="请输入"
                            value={text}
                            onChange={value => this.handleFirChange(value, 'paymentPercent', index)}
                        />%
                    </span> : `${text}%`
                }
            },
            {
                title: '付款金额（元，含税）',
                dataIndex: 'paymentAmount',
                key: 'paymentAmount',
                width: 120,
                render: (text, record, index) => {
                    const { byStageName } = record;
                    return byStageName !== '总计' ? (type == 'edit' ? <span>
                        <InputNumber
                            style={{ width: '90%' }}
                            min={0}
                            precision={2}
                            placeholder="请输入"
                            value={text}
                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}  //千分位展示
                            onChange={value => this.handleFirChange(value, 'paymentAmount', index)}
                        />
                    </span> : `${text}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')) : `${text}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                }
            }
        ];
        if (!!paymentPlanHasInflation) {
            columns.push({
                title: '通胀基数',
                dataIndex: 'inflationBase',
                key: 'inflationBase',
                width: 100,
                render: (text, record, index) => {
                    const { byStageName } = record;
                    let showText = '';
                    inflationBaseList.map(el => {
                        if (text == el.value) showText = el.label
                    })
                    return byStageName !== '总计' ? (type == 'edit' ? <span>
                        <Select
                            allowClear
                            style={{ width: '90%' }}
                            placeholder="请输入"
                            value={text}
                            onChange={value => this.handleFirChange(value, 'inflationBase', index)}
                        >
                            {inflationBaseOption}
                        </Select>
                    </span> : showText) : showText
                }
            },
            {
                title: '付款金额（元，含税）通胀后',
                dataIndex: 'paymentAmountWithInflation',
                key: 'paymentAmountWithInflation',
                width: 140,
                render: (text) => text ? `${text}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''
            })
        }
        columns.push({
            title: '备注',
            dataIndex: 'remarks',
            key: 'remarks',
            width: 120,
            render: (text, record, index) => {
                return type == 'edit' ? <Input
                    style={{ width: '90%' }}
                    placeholder="请输入"
                    value={text}
                    onChange={e => this.handleFirChange(e.target.value, 'remarks', index)}
                /> : text
            }
        })
        if (type == 'edit') {
            columns.push({
                title: '操作',
                dataIndex: 'operate',
                key: 'operate',
                width: 80,
                render: (text, record, index) => {
                    const { byStageName } = record;
                    return <div>
                        {byStageName !== '总计' ? <Popconfirm title="确定要删除吗?" onConfirm={() => this.deleteRow(index, 'firDel')}><a>删除</a> </Popconfirm> : '-'}
                    </div>
                }
            })
        }
        return columns
    }

    getDataSource = () => {
        const { firTableData } = this.state;
        let totalData = {
            byStageName: '总计',
            paymentPercent: 0,
            paymentAmount: 0,
            paymentAmountWithInflation: 0,
        };
        const computeTotalData = (key, el) => {
            totalData[key] = el[key] ? Number((totalData[key] + Number(el[key])).toFixed(2)) : totalData[key];
        }
        firTableData.map((el, index) => {
            if(index < firTableData.length - 1) {
                computeTotalData('paymentPercent', el);
                computeTotalData("paymentAmount", el);
                computeTotalData('paymentAmountWithInflation', el)
            }
        })
        if(!!firTableData.length) {
            firTableData[firTableData.length - 1] = { ...firTableData[firTableData.length - 1], ...totalData };
        }
        return !!firTableData.length ? firTableData : []
    }

    getSecColumns = () => {
        const { type } = this.state;
        const columns = [
            {
                title: '户名',
                dataIndex: 'paymentAccountName',
                key: 'paymentAccountName',
                width: 270,
                render: (text, record, index) => {
                    return type == 'edit' ? <Input
                        style={{ width: '90%' }}
                        placeholder="请输入"
                        value={text}
                        onChange={e => this.handleSecChange(e.target.value, 'paymentAccountName', index)}
                    /> : text
                }
            },
            {
                title: '开户行',
                dataIndex: 'paymentAccountBankName',
                key: 'paymentAccountBankName',
                width: 270,
                render: (text, record, index) => {
                    return type == 'edit' ? <Input
                        style={{ width: '90%' }}
                        placeholder="请输入"
                        value={text}
                        onChange={e => this.handleSecChange(e.target.value, 'paymentAccountBankName', index)}
                    /> : text
                }
            },
            {
                title: '账号字段',
                dataIndex: 'paymentAccountNumber',
                key: 'paymentAccountNumber',
                width: 270,
                render: (text, record, index) => {
                    return type == 'edit' ? <Input
                        style={{ width: '90%' }}
                        placeholder="请输入"
                        value={text}
                        onChange={e => this.handleSecChange(e.target.value, 'paymentAccountNumber', index)}
                    /> : text
                }
            }
        ];
        if (type == 'edit') {
            columns.push({
                title: '操作',
                dataIndex: 'operate',
                key: 'operate',
                width: 80,
                render: (text, record, index) => {
                    return <div>
                        <Popconfirm title="确定要删除吗?" onConfirm={() => this.deleteRow(index, 'secDel')}>
                            <a>删除</a> 
                        </Popconfirm>
                    </div>
                }
            })
        }
        return columns
    }

    deleteRow = (index, key) => {
        const { firTableData, secTableData } = this.state;
        if (key === 'firDel') {
            firTableData.splice(index, 1);
        } else {
            secTableData.splice(index, 1);
        }
        this.setState({ firTableData, secTableData });
    }

    handleFirChange = (value, key, index) => {
        const { firTableData, feesTotal: { detailTotalPrice, simpleTotalPrice } } = this.state;
        const { activeKey } = this.props;
        const computePrice = activeKey == 'DetailedPaymentPlan' ? detailTotalPrice : simpleTotalPrice;
        firTableData[index][key] = value;

        const computePaymentAmount = (obj) => {
            const { paymentAmount, inflationBase } = obj;
            let value = undefined;
            if(inflationBase && paymentAmount) {
               value = Number((paymentAmount * inflationBase).toFixed(2));
            } else if(paymentAmount){
                value = paymentAmount
            }
            return value
        }
        
        switch (key) {
            case 'paymentPercent': 
                firTableData[index].paymentAmount = value ? Number((computePrice * value * 0.01).toFixed(2)) : value;
                break;
            case 'paymentAmount':
                firTableData[index].paymentPercent = value ? Number((value * 100 / computePrice).toFixed(2)) : value;
                break;
        }
        firTableData[index].paymentAmountWithInflation = computePaymentAmount(firTableData[index])
        this.setState({ firTableData });
    }

    handleSecChange = (value, key, index) => {
        const { secTableData } = this.state;
        secTableData[index][key] = value;
        this.setState({ secTableData });
    }

    getContent = () => {
        const { firTableData, secTableData, type } = this.state;
        const { activeKey, paymentPlanHasInflation, recordData } = this.props;
        const { bdBaAuth, evaluateStatus } = recordData;
        const content = <div>
            <div className='detail_content'>
                <div className='content_header'>
                    <div className='header_title'>付款时间表</div>
                    {(bdBaAuth && evaluateStatus != 'STATE_PUBLISHED') &&
                        <div className='header_button'>
                            {
                                type == 'view' && <Button
                                    className='button_item'
                                    key='sort'
                                    type="primary"
                                    onClick={() => this.PaymentPlanSortModalRef.show(firTableData)}
                                >排序调整</Button>
                            }
                            {
                                (type == 'view' && (activeKey == 'SimplePaymentPlan' || activeKey == 'FteSimplePaymentPlan')) && <Button
                                    className="btn-yellow"
                                    key='noInflation'
                                    type="primary"
                                    onClick={() => this.noInflation()}
                                >{
                                        paymentPlanHasInflation ? '无通货膨胀费' : '有通货膨胀费'
                                    }</Button>
                            }
                            {
                                type == 'edit' && <Button
                                    className='button_item'
                                    key='firAdd'
                                    type="primary"
                                    onClick={() => this.add('firAdd')}
                                >添加</Button>
                            }
                        </div>
                    }
                </div>
                <Table
                    bordered
                    dataSource={this.getDataSource()}
                    columns={this.getFirColumns()}
                    pagination={false}
                />
            </div>
            <div className='detail_content'>
                <div className='content_header'>
                    <div className='header_title'>收款账户信息-人民币</div>
                    <div className='header_button'>
                        {
                            type == 'edit' && <Button
                                className='button_item'
                                key='secAdd'
                                type="primary"
                                onClick={() => this.add('secAdd')}
                            >添加</Button>
                        }
                    </div>
                </div>
                <Table
                    bordered
                    dataSource={secTableData}
                    columns={this.getSecColumns()}
                    pagination={false}
                />
            </div>
        </div>
        return content
    }

    noInflation = () => {
        const { activeKey, clinicalQuotationRecordId, paymentPlanHasInflation } = this.props;
        const { config } = this.state;
        const options = {
            method: 'POST',
            url: config.InflationUrl,
            data: { clinicalQuotationRecordId, paymentPlanHasInflation: paymentPlanHasInflation === 1 ? 0 : 1 },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.loadData(clinicalQuotationRecordId, activeKey);
                this.props.getClinicalQuotationRecord()
            }
        };
        $.sendRequest(options);
    }

    add = (key) => {
        const { firTableData, secTableData } = this.state;
        if (key === 'firAdd') {
            firTableData.splice(firTableData.length - 1, 0, {
                byStageName: byStageList[firTableData.length - 1]
            });
        } else {
            secTableData.push({});
        }
        this.setState({ firTableData, secTableData });
    }

    submit = () => {
        const { config, firTableData, secTableData } = this.state;
        const { activeKey, clinicalQuotationRecordId } = this.props;
        //必填校验
        let requiredName = '';
        firTableData.map((el, index, arr) => {
            if (arr.length - 1 !== index) {
                const { byStageName, paymentNode, paymentPercent, paymentAmount, paymentAmountWithInflation } = el;
                if (!byStageName) {
                    requiredName = '分期';
                    return
                }
                if (!paymentNode) {
                    requiredName = '付款节点';
                    return
                }
                if (paymentPercent !== 0 && !paymentPercent) {
                    requiredName = '付款比例';
                    return
                }
                if (paymentAmount !== 0 && !paymentAmount) {
                    requiredName = '付款金额（元，含税）';
                    return
                }
                if (paymentAmountWithInflation !== 0 && !paymentAmountWithInflation) {
                    requiredName = '付款金额（元，含税）通胀后';
                    return
                }
            }
        });
        secTableData.map(el => {
            const { paymentAccountBankName, paymentAccountName, paymentAccountNumber, } = el;
            if (!paymentAccountName) {
                requiredName = '户名';
                return
            }
            if (!paymentAccountBankName) {
                requiredName = '开户行';
                return
            }
            if (!paymentAccountNumber) {
                requiredName = '账号字段';
                return
            }
        });
        if (requiredName !== '') return message.warning(`${requiredName}不能为空！`)

        //分期、户名字段唯一性校验
        const byStageNameList = firTableData.map(el => el.byStageName);
        const paymentAccountNumberList = secTableData.map(el => el.paymentAccountNumber);
        if (new Set(byStageNameList).size != byStageNameList.length) {
            return message.warning('分期不能重复！')
        }
        if (new Set(paymentAccountNumberList).size != paymentAccountNumberList.length) {
            return message.warning('账号不能重复！')
        }

        let sendData = {};
        firTableData.map((el, index, arr) => {
            if (index !== arr.length - 1) {
                sendData[`paymentPlanList[${index}].quotationVisitPaymentPlanId`] = el.quotationVisitPaymentPlanId;
                sendData[`paymentPlanList[${index}].byStageName`] = el.byStageName;
                sendData[`paymentPlanList[${index}].paymentNode`] = el.paymentNode;
                sendData[`paymentPlanList[${index}].paymentPercent`] = el.paymentPercent;
                sendData[`paymentPlanList[${index}].paymentAmount`] = el.paymentAmount;
                sendData[`paymentPlanList[${index}].inflationBase`] = el.inflationBase;
                sendData[`paymentPlanList[${index}].paymentAmountWithInflation`] = el.paymentAmountWithInflation;
                sendData[`paymentPlanList[${index}].remarks`] = el.remarks;
            } else {
                sendData[`totalPlan.remarks`] = el.remarks;
            }

        });
        secTableData.map((el, index) => {
            sendData[`paymentAccountList[${index}].quotationVisitPaymentAccountId`] = el.quotationVisitPaymentAccountId;
            sendData[`paymentAccountList[${index}].paymentAccountBankName`] = el.paymentAccountBankName;
            sendData[`paymentAccountList[${index}].paymentAccountName`] = el.paymentAccountName;
            sendData[`paymentAccountList[${index}].paymentAccountNumber`] = el.paymentAccountNumber;
        });
        const options = {
            method: 'POST',
            url: config.saveUrl,
            data: { clinicalQuotationRecordId, ...sendData },
            dataType: 'json',
            doneResult: res => {
                message.success('修改成功');
                this.setState({ type: 'view' }, () => {
                    this.loadData(clinicalQuotationRecordId, activeKey);
                });
            }
        };
        $.sendRequest(options);
    }

    render() {
        const { type, config } = this.state;
        const { clinicalQuotationRecordId, activeKey, recordData } = this.props;
        const { bdBaAuth, evaluateStatus } = recordData;
        return (
            <div>
                <div style={{ fontSize: 20, fontWeight: 600, textAlign: 'center', margin: '20px 0' }}>
                    {config.title}
                </div>
                {this.getContent()}
                { 
                    (bdBaAuth && evaluateStatus != 'STATE_PUBLISHED') && <div className='Forecast_Params_footer'>
                        {
                            type === 'view' ?
                                <Button
                                    type="primary"
                                    onClick={() => this.setState({
                                        type: 'edit',
                                    })}
                                >编辑</Button> :
                                <div>
                                    <Button
                                        style={{ marginRight: 20 }}
                                        onClick={() => this.setState({
                                            type: 'view',
                                        }, () => this.loadData(clinicalQuotationRecordId, activeKey))}
                                    >取消</Button>
                                    <Button
                                        type="primary"
                                        onClick={this.submit}
                                    >确定</Button>
                                </div>
                        }
                    </div>
                }
                <PaymentPlanSortModal
                    ref={el => this.PaymentPlanSortModalRef = el}
                    loadData={this.loadData}
                    activeKey={activeKey}
                    clinicalQuotationRecordId={clinicalQuotationRecordId}
                />
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/clinicalEvaluation/clinicalEvaluationRecord/components/PaymentPlan.js